/**
 * MeetingSettingsService
 * Admin service for Meeting Management domain settings.
 * Route: api/meetings/settings
 * Controller: MeetingSettingsController.cs
 *
 * This is not a standard CRUD entity (single-row settings + feature-check), so it
 * extends BaseService directly rather than CrudService — mirrors ProjectSettingsService.
 */
import { BaseService } from '../base/BaseService';
export class MeetingSettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingSettingsService.DEFAULT_SERVICE_PATH,
            basePath: MeetingSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Get current meeting settings (secrets masked). GET /api/meetings/settings */
    async get() {
        const response = await this.getRaw();
        return response.data ?? null;
    }
    getRaw() {
        return this.http.get(this.buildUrl());
    }
    /**
     * Update meeting settings. Pass fresh plaintext calendar-sync secrets as query params
     * to (re)encrypt; omit to preserve stored values. PUT /api/meetings/settings
     */
    async update(settings, secrets) {
        const response = await this.updateRaw(settings, secrets);
        return response.data ?? null;
    }
    updateRaw(settings, secrets) {
        const params = new URLSearchParams();
        if (secrets?.googleClientSecret)
            params.set('googleClientSecret', secrets.googleClientSecret);
        if (secrets?.googleRefreshToken)
            params.set('googleRefreshToken', secrets.googleRefreshToken);
        if (secrets?.outlookClientSecret)
            params.set('outlookClientSecret', secrets.outlookClientSecret);
        if (secrets?.outlookRefreshToken)
            params.set('outlookRefreshToken', secrets.outlookRefreshToken);
        const qs = params.toString();
        const url = this.buildUrl() + (qs ? `?${qs}` : '');
        return this.http.put(url, settings);
    }
    /**
     * Check whether a feature is enabled (global toggle).
     * GET /api/meetings/settings/feature-check?feature=...
     */
    async isFeatureEnabled(feature) {
        const params = new URLSearchParams({ feature });
        const endpoint = this.getEndpoint('featureCheck', 'feature-check');
        const url = this.buildUrl(endpoint) + `?${params.toString()}`;
        const response = await this.http.get(url);
        return response.data?.enabled ?? false;
    }
}
MeetingSettingsService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingSettingsService.BASE_PATH = 'api/meetings/settings';
//# sourceMappingURL=MeetingSettingsService.js.map